import { BoxShadowLayout } from "layouts";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import styles from "./SectionCard.module.scss";

interface SectionCardProps {
  title: string;
  children: ReactNode;
}

const SectionCard = ({ title, children }: SectionCardProps) => {
  const { t } = useTranslation();

  return (
    <section>
      <h2 className={styles.title}>{t(title)}</h2>
      <BoxShadowLayout className={styles.card}>{children}</BoxShadowLayout>
    </section>
  );
};

export default SectionCard;
